export { DetailsPage } from './DetailsPage'
